<template>
  <div class="hidden-sm-and-down">
    <v-radio-group
        @change="changeVersion"
        :value="version"
      >
        <v-radio
          v-for="(ver, i) in versions"
          :key="i"
          :label="ver"
          :value="ver"
        />
      </v-radio-group>
  </div>

</template>

<script>
  export default {
    name: 'header-component-toggles',
    computed: {
      versions () {
        return this.$store.getters.getVersions
      },
      version () {
        return this.$store.getters.getAppVersion
      }
    },
    methods: {
      changeVersion (version) {
        if (version === this.version) return false
        this.$store.dispatch('setAppVersion', version)
      }
    }
  }
</script>
